/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Select_NoneInputs */



/**
* | output |
* | --- |
* | "Select None" |
*
* @param {Compare_Event_Groups_Select_NoneInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_select_none = /** @type {((inputs?: Compare_Event_Groups_Select_NoneInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Select_NoneInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionnez « Aucun »")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine auswählen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona Nessuno")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите «Нет»")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar ninguno")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择“无”")
	if (locale === "ja") return /** @type {LocalizedString} */ ("何も選択しない")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुछ मत चुनिए")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não selecionar nenhuma opção.")
	return /** @type {LocalizedString} */ ("Select None")
});